import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * 폼 필드 프레젠테이션 래퍼 — 라벨·필수 표시·에러/힌트를 통일된 자리에 렌더한다.
 * pk-input/pk-select 등 폼 컴포넌트 내부에서 사용하며, 직접 쓸 수도 있다
 * (커스텀 컨트롤을 같은 레이아웃으로 배치할 때).
 */
@Component({
  selector: 'pk-field',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (label(); as text) {
      <label class="pk-field__label" [attr.for]="forId()">
        {{ text }}
        @if (required()) {
          <em class="pk-field__req" aria-hidden="true">*</em>
        }
      </label>
    }
    <ng-content />
    @if (error(); as err) {
      <p class="pk-field__error">{{ err }}</p>
    } @else if (hint(); as help) {
      <p class="pk-field__hint">{{ help }}</p>
    }
  `,
  styles: `
    :host {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }

    .pk-field__label {
      font-size: 12px;
      font-weight: 700;
      color: var(--pk-text-sub);
    }

    .pk-field__req {
      color: var(--pk-danger);
      font-style: normal;
    }

    .pk-field__error {
      margin: 0;
      font-size: 12px;
      color: var(--pk-danger);
    }

    .pk-field__hint {
      margin: 0;
      font-size: 12px;
      color: var(--pk-text-muted);
    }
  `,
})
export class PkField {
  readonly label = input<string | null>(null);
  readonly required = input(false);
  readonly error = input<string | null>(null);
  readonly hint = input<string | null>(null);
  /** label[for] 연결 대상 컨트롤 id */
  readonly forId = input<string | null>(null);
}
